export default __webpack_public_path__ + "80311e3f721af20440de89369cd343f8.webp";